import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectRecentlyViewedOffers } from '../../selectors/recentlyViewed';
import { RecentlyViewed } from '../../components/RecentlyViewed';

export const RecentlyViewedContainer: React.FC = () => {
  const { recentlyViewed } = useSelector(selectRecentlyViewedOffers);

  if (!recentlyViewed.length) {
    return null;
  }

  return <RecentlyViewed offers={recentlyViewed} />;
};
